"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Timeline = _interopRequireDefault(require("./Timeline"));

var _RegionTrack = _interopRequireDefault(require("./RegionTrack"));

var _TrackGroup = _interopRequireDefault(require("./TrackGroup"));

var _Panel = _interopRequireDefault(require("../../../common/Panel/Panel"));

var _colorPalette = _interopRequireDefault(require("../../../common/colorPalette"));

var _connectToMedia = _interopRequireDefault(require("../../Media/connectToMedia"));

var _ProgressControls = _interopRequireDefault(require("../Controls/ProgressControls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.media);
};

var Index = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Index, _React$PureComponent);

  function Index(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.state = {
      isTimeLineVisible: false
    };
    return _this;
  }

  var _proto = Index.prototype;

  _proto.setTimelineVisibility = function setTimelineVisibility(ranges) {
    var that = this;
    that.setState({
      isTimeLineVisible: !that.state.isTimeLineVisible
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var updatePlayerTopSectionHeight = this.props.updatePlayerTopSectionHeight;
    updatePlayerTopSectionHeight();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        turns = _this$props.turns,
        detectors = _this$props.detectors,
        isSentimentAnalyzerOn = _this$props.isSentimentAnalyzerOn,
        mediaId = _this$props.mediaId,
        isChatTextMedia = _this$props.isChatTextMedia,
        metaData = _this$props.metaData,
        transcriptLength = _this$props.transcriptLength;
    return /*#__PURE__*/_react["default"].createElement(_Panel["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        overflow: "hidden"
      }
    }, /*#__PURE__*/_react["default"].createElement(_ProgressControls["default"], {
      isChatTextMedia: isChatTextMedia,
      mediaId: mediaId,
      isTimeLineVisible: this.state.isTimeLineVisible,
      setTimelineVisibility: function setTimelineVisibility() {
        return _this2.setTimelineVisibility();
      },
      messagesDuration: turns === null || turns === void 0 ? void 0 : turns.reduce(function (p, v) {
        return p.end > v.end ? p.end : v.end;
      }, -1)
    })), this.state.isTimeLineVisible && /*#__PURE__*/_react["default"].createElement(_Timeline["default"], {
      isSentimentAnalyzerOn: isSentimentAnalyzerOn,
      isChatTextMedia: isChatTextMedia,
      messagesDuration: turns === null || turns === void 0 ? void 0 : turns.reduce(function (p, v) {
        return p.end > v.end ? p.end : v.end;
      }, -1)
    }, /*#__PURE__*/_react["default"].createElement(_TrackGroup["default"], null, (0, _lodash.uniqBy)(turns, "speaker").map(function (_ref, i) {
      var speaker = _ref.speaker;
      return /*#__PURE__*/_react["default"].createElement(_RegionTrack["default"], {
        messagesDuration: turns === null || turns === void 0 ? void 0 : turns.reduce(function (p, v) {
          return p.end > v.end ? p.end : v.end;
        }, -1),
        turns: turns,
        isChatTextMedia: isChatTextMedia,
        transcriptLength: transcriptLength,
        key: speaker,
        icon: "user",
        title: speaker,
        regions: turns.filter(function (turn) {
          return turn.speaker === speaker;
        }),
        color: !i % 2 ? "#9aca62" : "#0079c0",
        height: 10,
        isSentimentAnalyzerOn: isSentimentAnalyzerOn
      });
    }), detectors.map(function (detector, i) {
      return /*#__PURE__*/_react["default"].createElement(_RegionTrack["default"], {
        isDetectorTrack: true,
        messagesDuration: turns === null || turns === void 0 ? void 0 : turns.reduce(function (p, v) {
          return p.end > v.end ? p.end : v.end;
        }, -1),
        turns: turns,
        isChatTextMedia: isChatTextMedia,
        transcriptLength: transcriptLength,
        key: detector.detector,
        icon: "alert",
        title: detector.name,
        regions: detector.intervals,
        color: _colorPalette["default"].gray.darken(0.5).hex(),
        height: 10
      });
    }))));
  };

  return Index;
}(_react["default"].PureComponent);

Index.propTypes = process.env.NODE_ENV !== "production" ? {
  isSentimentAnalyzerOn: _propTypes["default"].bool
} : {};

var _default = (0, _connectToMedia["default"])(mapStateToProps)(Index);

exports["default"] = _default;